export default "__VITE_ASSET__G$o1a5jf__"